import { ipRegex, tcpPortRegex } from 'constants/regex';
import { Base64 } from 'js-base64';
import * as Yup from 'yup';

export const ALL = 'all';
export const INPUT = 'input';
export const DROPDOWN = 'dropdown';
export const OBJECT_DROPDOWN = 'object_dropdown';
export const PORT_DROPDOWN = 'port_dropdown';

export const addObjectInitial = (type) => {
  return {
    type,
    ipnumber: '',
  };
};

export const addObjectValidationSchema = Yup.object({
  type: Yup.string(),
  ipnumber: Yup.string().when('type', {
    is: 'port',
    then: (schema) =>
      schema.required('vs/firewall.string68').test('is-valid-port', 'vs/firewall.string69', (value) => {
        if (!value) return false;
        return tcpPortRegex.test(value); 
      }),
    otherwise: (schema) =>
      schema.required('vs/firewall.string70').test('is-valid-ip', 'vs/firewall.string71', (value) => {
        if (!value) return false;
        // basic IPv4 format check
        return ipRegex.test(value); 
      }),
  }),
});

export const addNewRuleInitial = (uniqueProtocol, dst_service) => {
  return {
    enabled: 1,
    action: 'deny',
    protocol: uniqueProtocol[0]?.value || 'tcp',
    //src
    src_checkbox: ALL,
    src_ip_input: '',
    src_object_dropdown: '',
    //dst ip
    dst_ip_checkbox: ALL,
    dst_ip_input: '',
    dst_ip_object_dropdown: '',
    //dst service
    dst_service_checkbox: ALL,
    dst_service_dropdown: dst_service[0]?.value,
    dst_service_input: '',
    dst_service_object_dropdown: '',
  };
};

export const addNewRuleValidationSchema = Yup.object({
  enabled: Yup.number(),
  action: Yup.string(),
  protocol: Yup.string(),
  //src
  src_checkbox: Yup.string(),
  src_ip_input: Yup.string().when('src_checkbox', {
    is: INPUT,
    then: (schema) => schema.required('vs/firewall.string79'),
    otherwise: (schema) => schema.notRequired(),
  }),
  src_object_dropdown: Yup.string().when('src_checkbox', {
    is: OBJECT_DROPDOWN,
    then: (schema) => schema.required('vs/firewall.string80'),
    otherwise: (schema) => schema.notRequired(),
  }),
  //dst ip
  dst_ip_checkbox: Yup.string(),
  dst_ip_input: Yup.string().when('dst_ip_checkbox', {
    is: INPUT,
    then: (schema) => schema.required('vs/firewall.string79'),
    otherwise: (schema) => schema.notRequired(),
  }),
  dst_ip_object_dropdown: Yup.string().when('dst_ip_checkbox', {
    is: OBJECT_DROPDOWN,
    then: (schema) => schema.required('vs/firewall.string80'),
    otherwise: (schema) => schema.notRequired(),
  }),
  //dst service
  dst_service_checkbox: Yup.string(),
  dst_service_dropdown: Yup.string(),
  dst_service_input: Yup.string().when('dst_service_checkbox', {
    is: INPUT,
    then: (schema) => schema.required('vs/firewall.string79'),
    otherwise: (schema) => schema.notRequired(),
  }),
  dst_service_object_dropdown: Yup.string().when('dst_service_checkbox', {
    is: OBJECT_DROPDOWN,
    then: (schema) => schema.required('vs/firewall.string80'),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const editNewRuleInitial = (values, firewallServies, objectArr) => {
  const { action, dst_ip, dst_service, enabled, order, protocol, src, dst_service_object, dst_ip_object, src_object } =
    values;
  const isInDropdown = firewallServies?.network_services?.some(
    (data) => data.id == dst_service && (protocol == ALL ? true : data.protocol == protocol),
  );
  const isSrcInObjectDropdown = objectArr?.some((data) => data.value == src_object && data.type == 'ipv4');
  const isDstIpInObjectDropdown = objectArr?.some(
    (data) => data.value == dst_ip_object && (data.type == 'ipv4' || data.type == 'ipv6'),
  );
  const isDstServiceInObjectDropdown = objectArr?.some(
    (data) => data.value == dst_service_object && data.type == 'port',
  );
  return {
    action: action,
    enabled: enabled,
    order: order,
    protocol: protocol,
    //src
    src_checkbox: src == ALL || src == '0/0' ? ALL : isSrcInObjectDropdown ? OBJECT_DROPDOWN : INPUT,
    src_ip_input: src == ALL || src == '0/0' || isSrcInObjectDropdown ? '' : src,
    src_object_dropdown: src_object,
    //dst ip
    dst_ip_checkbox: dst_ip == ALL || dst_ip == '0/0' ? ALL : isDstIpInObjectDropdown ? OBJECT_DROPDOWN : INPUT,
    dst_ip_input: dst_ip == ALL || dst_ip == '0/0' || isDstIpInObjectDropdown ? '' : dst_ip,
    dst_ip_object_dropdown: dst_ip_object,
    //dst service
    dst_service_checkbox:
      dst_service == ALL ? ALL : isInDropdown ? PORT_DROPDOWN : isDstServiceInObjectDropdown ? OBJECT_DROPDOWN : INPUT,
    dst_service_dropdown: isInDropdown ? dst_service : '',
    dst_service_input: isInDropdown || isDstServiceInObjectDropdown || dst_service == ALL ? '' : dst_service,
    dst_service_object_dropdown: dst_service_object,
  };
};

export const editNewRuleValidationSchema = Yup.object({
  enabled: Yup.number(),
  action: Yup.string(),
  protocol: Yup.string(),
  //src
  src_checkbox: Yup.string(),
  src_ip_input: Yup.string().when('src_checkbox', {
    is: INPUT,
    then: (schema) =>
      schema.required('vs/firewall.string79').test('is-valid-ip', 'vs/firewall.string71', (value) => {
        if (!value) return false;
        return ipRegex.test(value);
      }),
    otherwise: (schema) => schema.notRequired(),
  }),
  src_object_dropdown: Yup.string().when('src_checkbox', {
    is: OBJECT_DROPDOWN,
    then: (schema) => schema.required('vs/firewall.string80'),
    otherwise: (schema) => schema.notRequired(),
  }),
  //dst ip
  dst_ip_checkbox: Yup.string(),
  dst_ip_input: Yup.string().when('dst_ip_checkbox', {
    is: INPUT,
    then: (schema) => schema.required('vs/firewall.string79'),
    otherwise: (schema) => schema.notRequired(),
  }),
  dst_ip_object_dropdown: Yup.string().when('dst_ip_checkbox', {
    is: OBJECT_DROPDOWN,
    then: (schema) => schema.required('vs/firewall.string80'),
    otherwise: (schema) => schema.notRequired(),
  }),
  //dst service
  dst_service_checkbox: Yup.string(),
  dst_service_dropdown: Yup.string(),
  dst_service_input: Yup.string().when('dst_service_checkbox', {
    is: INPUT,
    then: (schema) => schema.required('vs/firewall.string79'),
    otherwise: (schema) => schema.notRequired(),
  }),
  dst_service_object_dropdown: Yup.string().when('dst_service_checkbox', {
    is: OBJECT_DROPDOWN,
    then: (schema) => schema.required('vs/firewall.string80'),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const handleConvert = (value) => (value == '' || value == undefined || value == null ? '' : Base64.atob(value));
